// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './auth.es-AR.json';
import esCL from './auth.es-CL.json';
import esCO from './auth.es-CO.json';
import esMX from './auth.es-MX.json';
import ptBR from './auth.pt-BR.json';

const authLocales: DomainTranslations = {
  // the name should be "auth", we need to replace all translate in
  // the auth domain that is current use the login key
  name: 'login',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.COLOMBIA]: esCO,
    [Locale.CHILE]: esCL,
  },
};

export default authLocales;
